import {
  MediaBreakpoints,
  useIsViewPortLessOrEqualTo,
} from './hooks/useIsViewPortLessOrEqualTo';

type StandardTransitionEasing = [number, number, number, number];

type StandardTransition = {
  duration: number;
  delay: number;
  ease: StandardTransitionEasing;
};

export type AnimationSettings = {
  standardTransitionDuration: number;
  standardTransitionDelay: number;
  standardTransitionDistance: string;
  standardTransitionEasing: StandardTransitionEasing;
  standardTransitionStagger: number;
  standardViewportTrigger: 'some' | number;
  standardTransition: StandardTransition;
};

export const animationSettings = (): AnimationSettings => {
  const isMobileSettings = useIsViewPortLessOrEqualTo(MediaBreakpoints.MOBILE);

  const standardTransitionDuration = isMobileSettings ? 0.5 : 1;
  const standardTransitionDelay = 0.2;
  const standardTransitionDistance = '32px';
  const standardTransitionEasing: StandardTransitionEasing = [
    0.25, 0.46, 0.45, 0.94,
  ];
  const standardTransitionStagger = 0.15;
  const standardViewportTrigger = isMobileSettings ? 'some' : 0.1;

  const standardTransition: StandardTransition = {
    duration: standardTransitionDuration,
    delay: standardTransitionDelay,
    ease: standardTransitionEasing,
  };

  return {
    standardTransitionDuration,
    standardTransitionDelay,
    standardTransitionDistance,
    standardTransitionEasing,
    standardTransitionStagger,
    standardViewportTrigger,
    standardTransition,
  };
};
